export default __webpack_public_path__ + "static/media/spinner.28751aa4.svg";